/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfRevisionCommentResponseFromDiscriminatorValue, createRevisionCommentResponseFromDiscriminatorValue, serializeRevisionCommentCreateRequest, serializeRevisionCommentResponse, type HttpValidationProblemDetails, type IError, type PaginatedResultOfRevisionCommentResponse, type RevisionCommentCreateRequest, type RevisionCommentResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type WithCommentItemRequestBuilder, WithCommentItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/comments
 */
export interface CommentsRequestBuilder extends BaseRequestBuilder<CommentsRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.files.item.revisions.item.comments.item collection
     * @param commentId Unique identifier of the item
     * @returns {WithCommentItemRequestBuilder}
     */
     byCommentId(commentId: Guid) : WithCommentItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfRevisionCommentResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<CommentsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfRevisionCommentResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<RevisionCommentResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: RevisionCommentCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<RevisionCommentResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<CommentsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: RevisionCommentCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface CommentsRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const CommentsRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/comments{?page*,pageSize*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CommentsRequestBuilderNavigationMetadata: Record<Exclude<keyof CommentsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCommentId: {
        requestsMetadata: WithCommentItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["commentId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CommentsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CommentsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfRevisionCommentResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: CommentsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createRevisionCommentResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRevisionCommentCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
